//授课签到
export const SK_SIGIN_ADD = 'sk_sigin_add'
export const SK_SIGIN_STU_LIST = 'sk_sigin_stu_list'
export const SK_SIGIN_LIST = 'sk_sigin_list'
export const SK_SIGIN_ON = 'sk_sigin_on'
export const SK_SIGIN_DETAIL = 'sk_sigin_detail'
export const SK_SIGIN_EDIT = 'sk_sigin_edit'
export const SK_SIGIN_STU_EDIT = 'sk_sigin_stu_edit'
export const SK_SIGIN_STU_BATCH_EDIT = 'sk_sigin_stu_batch_edit'